import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sumBy } from "lodash";

const Billingcontext = React.createContext();

const init = {
  addedProducts: [],
  orderType: "dine_in",
  orderId: "",
};

const BillingProvider = ({ children, ...props }) => {
  const [state, setState] = React.useState({ ...init, b2bBill: false });
  const customTaxType = useSelector((state) => state.shopDetails.customTaxType);
  const billingPayload = useSelector((state) => state.billingPayload.data);
  const taxList = useSelector((state) => state.taxList.taxList);
  const { productList } = useSelector((state) => state.products);
  const invoiceSettings = useSelector(
    (state) => state.newInvoicesettings.newInvoicesettings
  );
  const dispatch = useDispatch();
  //const discount = useSelector((state) => state.billingPayload.discount);

  const itemDiscountCalc = useCallback((total, discount = 0, discountType) => {
    let result = 0;

    console.log("itemDiscountCalc", {
      total,
      discount,
      result,
      discountType,
    });
    if (discount === "" || !discount) discount = 0;
    if (discountType === "flat") {
      result = parseFloat(discount);
    }
    if (discountType === "percentage") {
      result = (parseFloat(total) * parseFloat(discount)) / 100;
    }

    return result;
  }, []);

  const getLoyaltyValue = useCallback(() => {
    let result = 0;
    let loyalty = billingPayload.loyalty;
    if (loyalty) {
      if (loyalty === "" || Object.keys(loyalty).length === 0) {
        result = 0;
      } else {
        result = parseFloat(loyalty.minLoyaltyPointsReq);
      }
    }
    return result;
  }, [billingPayload.loyalty]);

  const getCouponValue = useCallback(() => {
    let result = 0;
    let coupon = billingPayload.coupon;
    if (coupon) {
      if (coupon === "" || !coupon || Object.keys(coupon).lenght > 0) {
        coupon = 0;
      }
      result = parseFloat(coupon?.discountAmount || 0);
    }
    return result;
  }, [billingPayload.coupon]);

  const getSubTotal = useCallback(() => {
    let total = 0;
    state?.addedProducts?.forEach((item) => {
      total += parseFloat(item.itemTotal);
    });
    return total;
  }, [state.addedProducts]);

  const taxableValueFunc = React.useCallback(
    (
      productPrice = 0,
      productTax = 0,
      count,
      taxIncExc = "inclusive",
      isTax
    ) => {
      let result = 0;
      if (isTax) {
        if (taxIncExc === "inclusive") {
          result =
            (productPrice / (100 + parseFloat(productTax || 0))) *
            parseFloat(count || 0) *
            100;
        } else if (taxIncExc === "exclusive") {
          result = productPrice * parseFloat(count || 0);
        } else {
          result = productPrice * count;
        }
      } else {
        result = productPrice * count;
      }
      console.log("result1111", result);
      return result;
    },
    []
  );

  const taxTypeFunc = useCallback(
    (taxableValue, seletedTax, isTax) => {
      const customTaxValue = {};
      if (isTax) {
        seletedTax.taxType?.forEach((tax) => {
          const taxTypeName =
            customTaxType.find((customTax) => customTax.taxId === tax)
              ?.taxName || tax;
          customTaxValue[taxTypeName] =
            (customTaxValue[taxTypeName] || 0) +
            parseFloat(
              taxableValue * (parseFloat(seletedTax[taxTypeName] || 0) / 100)
            );
        });
      }
      const sumOfTax = Object.values(customTaxValue).reduce(
        (acc, cur) => acc + cur,
        0
      );
      const itemTotal = parseFloat(taxableValue) + sumOfTax;
      return {
        ...customTaxValue,
        taxType: Object.keys(customTaxValue),
        itemTotal,
        taxableValue,
        totalBeforeTax: taxableValue,
      };
    },
    [customTaxType]
  );

  const getTaxableValueAndTaxs = React.useCallback(
    (product, price = 0, quantity = 0, isDiscount, isTax) => {
      let selectedTax = {};
      let taxableValue = 0;
      let totalTaxPercentage = 0;
      let taxs = {};
      let newProduct = {};
      let itemTotal = 0;

      if (isTax) {
        if (
          product.taxId &&
          product.taxId !== "Select Tax" &&
          product.taxIncExc !== "Inclusive/Exclusive"
        ) {
          selectedTax = taxList.find(
            (data) => data.taxId.toString() === product.taxId.toString()
          );
          totalTaxPercentage = selectedTax.taxType.reduce((acc, curr) => {
            const taxTypeName =
              customTaxType.find((customTax) => customTax.taxId === curr)
                ?.taxName || curr;
            return acc + parseFloat(selectedTax[taxTypeName] || 0);
          }, 0);
          taxableValue = taxableValueFunc(
            price,
            totalTaxPercentage,
            quantity,
            product.taxIncExc,
            isTax
          );
          console.log("taxableValue", taxableValue);
          taxs = taxTypeFunc(taxableValue, selectedTax, isTax);
          console.log("taxs111", taxs);
          itemTotal = taxs.itemTotal;
        } else {
          itemTotal = price * parseFloat(quantity);
        }
      } else {
        itemTotal = price * parseFloat(quantity);
      }
      let discount = 0;

      if (isDiscount) {
        console.log("taxs1122", taxs.itemTotal ? taxs.itemTotal : itemTotal);
        discount = itemDiscountCalc(
          taxs.itemTotal ? taxs.itemTotal : itemTotal,
          product.discountPrice,
          product.discountType
        );
      }
      console.log("discount111", discount, itemTotal);
      newProduct = {
        ...product,
        ...taxs,
        count: quantity,
        productPrice: price,
        taxType: taxs.taxType ? taxs.taxType : [],
        totalTax: totalTaxPercentage,
        itemTotal:
          product.discountType === "flat"
            ? itemTotal - discount * quantity
            : itemTotal - discount,
      };
      return newProduct;
    },
    [itemDiscountCalc, taxList, taxableValueFunc, taxTypeFunc, customTaxType]
  );

  const removeProductFromBilling = React.useCallback((productId) => {
    setState((state) => {
      return {
        ...state,
        addedProducts: state.addedProducts?.filter(
          (item) => item.productId !== productId
        ),
      };
    });
  }, []);

  const updateProductPriceFromProduct = React.useCallback(
    (product, price = 0) => {
      let newProducts = getTaxableValueAndTaxs(
        product,
        price,
        product.count,
        invoiceSettings.itemdiscount,
        invoiceSettings.itemleveltax
      );
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item) => {
            if (item.productId === product.productId) {
              // item.productPrice = price;
              return {
                ...newProducts,
                productPrice: price,
              };
            }
            return item;
          }),
        };
      });
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
    ]
  );

  const ItemDiscountTaxCheckbox = useCallback(
    (isDiscount, isTax) => {
      setState((prev) => {
        const updatedProducts = prev.addedProducts.map((product) => {
          const b2bProductPrice = product?.b2bProductPrice
            ? product.b2bProductPrice
            : product.productPrice;
          const productPrice = state.b2bBill
            ? b2bProductPrice
            : product.productPrice;
          let updateProduct = getTaxableValueAndTaxs(
            product,
            productPrice,
            product.count,
            isDiscount,
            isTax
          );
          console.log("updateProduct", updateProduct);
          return updateProduct;
        });
        return {
          ...prev,
          addedProducts: updatedProducts,
        };
      });
    },
    [getTaxableValueAndTaxs, state.b2bBill]
  );

  const getDiscountValue = useCallback(() => {
    let discount = 0;
    const subTotal = getSubTotal();
    const type = billingPayload.discountType;
    const value = billingPayload.discount || 0;
    if (type === "flat") {
      discount = parseFloat(value);
    } else if (type === "percentage") {
      discount = (parseFloat(subTotal) * parseFloat(value)) / 100;
    }
    return discount;
  }, [getSubTotal, billingPayload.discountType, billingPayload.discount]);

  const updateProductQuantityFromProduct = React.useCallback(
    (product, quantity = 0) => {
      const b2bProductPrice = product?.b2bProductPrice
        ? product.b2bProductPrice
        : product.productPrice;
      const productPrice = state.b2bBill
        ? b2bProductPrice
        : product.productPrice;
      let newProducts = getTaxableValueAndTaxs(
        product,
        productPrice,
        quantity ? quantity : 0,
        invoiceSettings.itemdiscount,
        invoiceSettings.itemleveltax
      );
      console.log("newProducts777", newProducts);
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item, index) => {
            if (item.productId === product.productId) {
              return {
                ...newProducts,
                count: quantity,
              };
            }
            return item;
          }),
        };
      });
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
      state.b2bBill,
    ]
  );

  const updateQuantityForProduct = React.useCallback(
    (product = 0, quantity = 0) => {
      setState((state) => {
        return {
          ...state,
          products: state.products.map((item) => {
            if (item.product.productId === product.productId) {
              return {
                ...item,
                product: {
                  ...item.product,
                  quantity: quantity,
                },
              };
            }
            return item;
          }),
        };
      });
    },
    []
  );

  const updateExistingProductQuantity = React.useCallback(
    (product) => {
      const quantity = parseFloat(product.count) + 1;
      const b2bProductPrice = product?.b2bProductPrice
        ? product.b2bProductPrice
        : product.productPrice;
      const productPrice = state.b2bBill
        ? b2bProductPrice
        : product.productPrice;
      const newProduct = getTaxableValueAndTaxs(
        product,
        productPrice,
        quantity,
        invoiceSettings.itemdiscount,
        invoiceSettings.itemleveltax
      );
      console.log("quantity333", quantity, product.count);
      setState((state) => {
        return {
          ...state,
          addedProducts: state.addedProducts.map((item) => {
            if (item.productId === product.productId) {
              return {
                ...item,
                ...newProduct,
                count: quantity,
              };
            }
            return item;
          }),
        };
      });
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
      state.b2bBill,
    ]
  );
  const addProductToBilling = React.useCallback(
    (product, isItemdiscount, isItemleveltax) => {
      const checkAlreadyExist = state.addedProducts.find(
        (item) => item.productId === product.productId
      );
      const itemdiscount = isItemdiscount
        ? isItemdiscount
        : invoiceSettings.itemdiscount;
      const itemleveltax = isItemleveltax
        ? isItemleveltax
        : invoiceSettings.itemleveltax;
      if (checkAlreadyExist) {
        updateExistingProductQuantity(checkAlreadyExist);
      } else {
        const b2bProductPrice = product?.b2bProductPrice
          ? product.b2bProductPrice
          : product.productPrice;
        const productPrice = state?.b2bBill
          ? b2bProductPrice
          : product.productPrice;
        let newProducts = getTaxableValueAndTaxs(
          product,
          productPrice,
          product.count,
          itemdiscount,
          itemleveltax
        );
        setState((state) => {
          return {
            ...state,
            addedProducts: [newProducts, ...state.addedProducts],
          };
        });
      }
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
      state.addedProducts,
      updateExistingProductQuantity,
      state.b2bBill,
    ]
  );

  const addProductToBillingFromRouterChange = React.useCallback(
    (product) => {
      const b2bProductPrice = product?.b2bProductPrice
        ? product.b2bProductPrice
        : product.productPrice;
      const productPrice = state.b2bBill
        ? b2bProductPrice
        : product.productPrice;
      let newProducts = getTaxableValueAndTaxs(
        product,
        productPrice,
        product.count,
        invoiceSettings.itemdiscount,
        invoiceSettings.itemleveltax
      );
      setState((state) => {
        return {
          ...state,
          addedProducts: [newProducts, ...state.addedProducts],
        };
      });
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
      state.b2bBill,
    ]
  );

  const updateProductPriceWhileSwitching = React.useCallback(
    (b2bBill) => {
      setState((prev) => ({
        ...prev,
        addedProducts: prev.addedProducts.map((tempProduct) => {
          const product =
            productList.find(
              (item) => item.productId === tempProduct.productId
            ) || tempProduct;
          const b2bProductPrice = product?.b2bProductPrice
            ? product.b2bProductPrice
            : product?.productPrice;
          const productPrice = b2bBill
            ? b2bProductPrice
            : product?.productPrice;
          let newProducts = getTaxableValueAndTaxs(
            { ...product, isExist: tempProduct.isExist },
            productPrice,
            tempProduct.count,
            invoiceSettings.itemdiscount,
            invoiceSettings.itemleveltax
          );
          return newProducts;
        }),
      }));
    },
    [
      getTaxableValueAndTaxs,
      invoiceSettings.itemdiscount,
      invoiceSettings.itemleveltax,
      productList,
    ]
  );

  const getOtherChargeValue = useCallback(
    (product) => {
      const otherCharges = billingPayload.otherCharges;

      const sumOtherCharges = sumBy(otherCharges, (o) =>
        parseFloat(o.price || 0)
      );
      return sumOtherCharges;
    },
    [billingPayload.otherCharges]
  );

  const getTotalAmount = useCallback(() => {
    const discount = getDiscountValue();
    const coupon = getCouponValue();
    const totalDiscountValue = discount + coupon;
    let totalAmount = 0;
    const sumOtherCharges = getOtherChargeValue();

    state.addedProducts.forEach((item) => {
      totalAmount += parseFloat(item.itemTotal);
    });
    return totalAmount + sumOtherCharges - totalDiscountValue;
  }, [
    getDiscountValue,
    getCouponValue,
    getOtherChargeValue,
    state.addedProducts,
  ]);

  const clearAll = useCallback(() => {
    setState((prev) => ({
      ...prev,
      addedProducts: [],
    }));
    dispatch({
      type: "CLEAR_ALL_BILLING_PAYLOAD",
    });
  }, [dispatch]);

  const setSwitch = React.useCallback((value) => {
    setState((prev) => ({
      ...prev,
      b2bBill: value,
    }));
  }, []);

  const setOrderTypeAndId = React.useCallback((orderType, orderId) => {
    setState((prev) => ({
      ...prev,
      orderType: orderType,
      orderId: orderId,
    }));
  }, []);

  const value = React.useMemo(() => {
    return {
      state,
      setState,
      taxList,
      setSwitch,
      addProductToBilling,
      removeProductFromBilling,
      updateQuantityForProduct,
      updateProductPriceFromProduct,
      updateProductQuantityFromProduct,
      updateExistingProductQuantity,
      getLoyaltyValue,
      getTotalAmount,
      getSubTotal,
      clearAll,
      getCouponValue,
      getDiscountValue,
      getOtherChargeValue,
      ItemDiscountTaxCheckbox,
      addProductToBillingFromRouterChange,
      updateProductPriceWhileSwitching,
      setOrderTypeAndId,
      getTaxableValueAndTaxs,
    };
  }, [
    taxList,
    getTotalAmount,
    setState,
    setSwitch,
    getTaxableValueAndTaxs,
    addProductToBilling,
    setOrderTypeAndId,
    removeProductFromBilling,
    updateQuantityForProduct,
    updateProductPriceFromProduct,
    updateProductQuantityFromProduct,
    updateExistingProductQuantity,
    getLoyaltyValue,
    getCouponValue,
    getDiscountValue,
    state,
    getSubTotal,
    clearAll,
    getOtherChargeValue,
    ItemDiscountTaxCheckbox,
    addProductToBillingFromRouterChange,
    updateProductPriceWhileSwitching,
  ]);

  return (
    <Billingcontext.Provider value={value} {...props}>
      {children}
    </Billingcontext.Provider>
  );
};

export default BillingProvider;

export const useBilling = () => {
  const context = React.useContext(Billingcontext);
  if (context === undefined) {
    throw new Error(`useBilling must be used within a BillingProvider`);
  }
  return context;
};

export const useSwitchBill = () => {
  const context = React.useContext(Billingcontext);
  if (context === undefined) {
    throw new Error(`useBilling must be used within a BillingProvider`);
  }
  return [context.state.b2bBill, context.setSwitch];
};
